import API from "../services/api";
import StorageService from '../services/general/storage';
import moment from "moment";
const attribute = "calendar";

const Service = {
  get: id => {
    return new Promise((resolve, reject) => {
      API.get(id ? attribute + "/" + id : attribute).then(
        result => {

          if (id) {
            resolve(result);
            StorageService.setCollectionObject(attribute, id, result);
          } else {
            let newList = [];
            for (let i = 0; i < result.length; i++) {
              newList.push(result[i]);
              if (moment(result[i].start).format('YYYY-MM-DD') != moment(result[i].end).format('YYYY-MM-DD') && moment(result[i].end).isAfter(moment(result[i].start))) {
                result[i].multiDay = true;
                let start = moment(result[i].start).format('YYYY-MM-DD');
                let end = moment(result[i].end).format('YYYY-MM-DD');
               
                while (start < end ) {
                  
                  let newItem = Object.assign({}, result[i]);
                  newItem.start = moment(start).add(1, 'days').toDate();
                  newItem.multiDay = true;
                  newList.push(newItem);
                  start = moment(start).add(1, 'days').format('YYYY-MM-DD');
                }
              }
            }
            newList = newList.sort((a, b) => {
              if (moment(a.start).isBefore(moment(b.start))) return -1;
              if (moment(a.start).isAfter(moment(b.start))) return 1;
              return 0;
            });
           
            resolve(newList);
            StorageService.setCollectionObject(attribute, id, newList);
          }

        },
        error => {
          StorageService.getCollectionObject(attribute, id).then((foundStorage) => {
            resolve(foundStorage);
          }, (err) => {
            reject(err);
          })
        }
      );
    });
  },

  save: item => {
    return new Promise((resolve, reject) => {
      if (item._id) {
        API.post(attribute + "/" + item._id, [], item).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
      } else {
        API.put(attribute, [], item).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
      }
    });
  },

  delete: id => {
    return new Promise((resolve, reject) => {
      API.deleteItem(attribute + "/" + id).then(
        result => {
          resolve(result);
        },
        error => {

          reject(error);
        }
      );
    });
  },
};

export default Service;
